"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateLibraryApi = exports.TemplateAccessLevel = void 0;
const apiFetch_1 = require("../utils/apiFetch");
var TemplateAccessLevel;
(function (TemplateAccessLevel) {
    TemplateAccessLevel["PUBLIC"] = "public";
    TemplateAccessLevel["ORGANIZATION"] = "organization";
    TemplateAccessLevel["PERSONAL"] = "personal";
})(TemplateAccessLevel || (exports.TemplateAccessLevel = TemplateAccessLevel = {}));
const API_BASE = process.env.WITHOUT_GATEWAY
    ? process.env.REACT_APP_TEMPLATE_BUILDER_URL
    : `${process.env.REACT_APP_API_BASE_URL}/v1/template-builder`;
exports.templateLibraryApi = {
    getTemplates() {
        return __awaiter(this, arguments, void 0, function* (params = {}) {
            const queryParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    queryParams.append(key, value.toString());
                }
            });
            return (0, apiFetch_1.apiFetch)(`${API_BASE}/template-library?${queryParams.toString()}`, {
                method: 'GET',
            });
        });
    },
    getTemplateById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, apiFetch_1.apiFetch)(`${API_BASE}/template-library/${id}`, {
                method: 'GET',
            });
        });
    },
    createTemplate(templateData) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, apiFetch_1.apiFetch)(`${API_BASE}/template-library`, {
                method: 'POST',
                body: JSON.stringify(templateData),
            });
        });
    },
    updateTemplate(id, templateData) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, apiFetch_1.apiFetch)(`${API_BASE}/template-library/${id}`, {
                method: 'PATCH',
                body: JSON.stringify(templateData),
            });
        });
    },
    deleteTemplate(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, apiFetch_1.apiFetch)(`${API_BASE}/template-library/${id}`, {
                method: 'DELETE',
            });
        });
    },
    incrementUsageCount(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, apiFetch_1.apiFetch)(`${API_BASE}/template-library/${id}/use`, {
                method: 'POST',
            });
        });
    },
};
